import React from 'react';
import Money from '../../../../components/Money';

// eslint-disable-next-line react/prop-types
const Totals = ({ total }) => (
  <div className="u-flex u-justify-content-space-between u-align-end">
    <div className="u-text-large u-fw-bold u-hide-on-mobile u-mt-5">Total price</div>
    <div className="u-text-large u-fw-bold u-mt-1 u-hide-on-desktop">Total price</div>
    <div
      className="u-text-huge u-ta-right c-receipt-total--light"
    >
      <Money noDecimalsIfInt>{total}</Money>
    </div>
  </div>
);

export default Totals;



// WEBPACK FOOTER //
// ./src/app/notifications/shop/ShopNewAppointment/components/Totals.jsx